// extracted by mini-css-extract-plugin
export default {"earth":"earth_earth__YY5-f"};